import { render, staticRenderFns } from "./TagsFrund.vue?vue&type=template&id=da238644&"
import script from "./TagsFrund.vue?vue&type=script&lang=js&"
export * from "./TagsFrund.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports